import axios from 'axios';

import { env } from 'config';
import {
  FiatCurrencyExchange,
  FiatCurrencyExchangeRate,
  FiatCurrencyExchangeRateHistory,
  PriceChartFilters,
} from 'types';

import { createCrudApi } from './crud.api';

const url = `${env.apiUrl}/fiat-currency-exchange`;

const getRates = async (): Promise<FiatCurrencyExchangeRate[]> =>
  (await axios.get(`${url}/rates`)).data;

const getRatesHistory = async (
  body: PriceChartFilters,
): Promise<FiatCurrencyExchangeRateHistory[]> =>
  (await axios.post(`${url}/rates/history`, body)).data;

export const fiatCurrencyExchangeApi = {
  ...createCrudApi<FiatCurrencyExchange>('/fiat-currency-exchange'),
  getRates,
  getRatesHistory,
};
